<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <div class="form-group row">
        <label class="col-form-label col-sm-4" for="">{{ t('selectDurationLabel', 'selectDurationLabel') }}</label>
        <div class="col-sm-8">
          <select name="durationInMonth" @change="fillData()" class="form-control" v-model="durationInMonths">
            <option value="1">{{ t('timeLapse1Month', 'timeLapse1Month') }}</option>
            <option value="2">{{ t('timeLapse2Months', 'timeLapse2Months') }}</option>
            <option value="3">{{ t('timeLapse3Months', 'timeLapse3Months') }}</option>
            <option value="4">{{ t('timeLapse4Months', 'timeLapse4Months') }}</option>
            <option value="5">{{ t('timeLapse5Months', 'timeLapse5Months') }}</option>
            <option value="6">{{ t('timeLapse6Months', 'timeLapse6Months') }}</option>
            <option value="7">{{ t('timeLapse7Months', 'timeLapse7Months') }}</option>
            <option value="8">{{ t('timeLapse8Months', 'timeLapse8Months') }}</option>
            <option value="9">{{ t('timeLapse9Months', 'timeLapse9Months') }}</option>
            <option value="10">{{ t('timeLapse10Months', 'timeLapse10Months') }}</option>
            <option value="11">{{ t('timeLapse11Months', 'timeLapse11Months') }}</option>
            <option value="12">{{ t('timeLapse12Months', 'timeLapse12Months') }}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="col-12 relative-position">
      <loading
        id="widget-loading-spinner"
        class="align-items-center test"
        :color="'#047bf8'"
        :loader="'spinner'"
        :active="isLoading"
        :transition="'fade'"
        :is-full-page="false">
      </loading>
      <pie-chart :download="true" :data="dataCollection" width="100%" :donut="true" :messages="{empty: t('noDataAvailable', 'noDataAvailable')}"></pie-chart>
    </div>
  </div>
</template>
<script>
import Loading from 'vue-loading-overlay'

export default {
 name: 'BatchesStatusChart',
  data() {
    return {
      dataCollection: {},
      durationInMonths: 6,
      isLoading: true
    }
  },
  components: {
    Loading
  },
  created () {
    this.fillData()
  },
  methods: {
    fillData(){
      this.isLoading = true
      this.$store.dispatch("widgetsStore/getBatchesStatusStats", {durationInMonths: this.durationInMonths}).then(response => {
        if(response.returnData) {
          this.dataCollection = response.returnData
        }
        this.isLoading = false
      })
    }
  }
}
</script>

<style scoped>
  .relative-position {
    position: relative;
  }
  .test {
    transition: all 2s linear;
  }
</style>
